export default [
  {
    path: '/content/suggestions',
    name: 'content-suggestions',
    component: () => import('@/views/content/SuggestionList.vue'),
    meta: {
      resource: 'content',
      action: 'view',
    },
  },
  {
    path: '/content/suggestions/:id',
    name: 'content-suggestion-view',
    component: () => import('@/views/content/SuggestionView.vue'),
    meta: {
      navActiveLink: 'content-suggestions',
      resource: 'content',
      action: 'view',
    },
  },
]
